import React from "react";
import { Redirect } from "react-router";
import Cabecalho from "../../components/Pagina/Cabecalho";
import { store } from "../../store";

const InicioPagina = () => {
	return (
		<React.Fragment>
			<Cabecalho title={"Home"} />
			{store.getState().authReducer.pipedriveDealId && (
				<Redirect to={"/orcamento/criar"} />
			)}
			{store.getState().authReducer.orcamentoId && (
				<Redirect to={"/orcamento/aceite"} />
			)}
		</React.Fragment>
	);
};

export default InicioPagina;
